const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://yeliigame-production.up.railway.app/api';

class ApiService {
    constructor() {
        this.baseURL = API_BASE_URL;
    }

    async request(endpoint, options = {}) {
        const url = `${this.baseURL}${endpoint}`;
        
        const defaultOptions = {
            headers: {
                'Content-Type': 'application/json',
                ...options.headers,
            },
        };

        const config = {
            ...defaultOptions,
            ...options,
        };

        try {
            const response = await fetch(url, config);
            
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('API request failed:', error);
            throw error;
        }
    }

    // Méthodes compatibles Axios
    async get(endpoint) {
        return this.request(endpoint);
    }

    async post(endpoint, data) {
        return this.request(endpoint, {
            method: 'POST',
            body: JSON.stringify(data),
        });
    }

    async put(endpoint, data) {
        return this.request(endpoint, {
            method: 'PUT',
            body: JSON.stringify(data),
        });
    }

    async delete(endpoint) {
        return this.request(endpoint, {
            method: 'DELETE',
        });
    }

    // Méthodes spécifiques
    async getMatches() {
        return this.request('/matches');
    }

    async getConfig() {
        return this.request('/config');
    }

    async participate(matchId, prediction, phoneNumber, operator, country, email) {
        return this.request('/participate', {
            method: 'POST',
            body: JSON.stringify({
                matchId,
                prediction,
                phoneNumber,
                operator,
                country,
                email
            }),
        });
    }

    async getParticipationStatus(participationId) {
        return this.request(`/participate/${participationId}`);
    }

    async getParticipationFee(country, operator) {
        return this.request(`/participate/fee?country=${country}&operator=${operator}`);
    }

    async getPaymentStatus(transactionId) {
        return this.request(`/participate/payment/${transactionId}`);
    }

    async healthCheck() {
        return this.request('/health');
    }
}

export default new ApiService(); 